import { useState, useRef } from 'react';
import { Input, Button, Tag, Space, Grid  } from 'antd';

const { useBreakpoint } = Grid;

function RemoveAttrsInput({ value, onChange }) {
  const [selector, setSelector] = useState('');
  const [attr, setAttr] = useState('');
  const selectorRef = useRef(null);
  const screens = useBreakpoint(); // برای واکنش‌گرایی

  const addAttr = () => {
    const trimmedSelector = selector.trim();
    const trimmedAttr = attr.trim();

    if (trimmedSelector && trimmedAttr) {
      onChange([...value, { selector: trimmedSelector, attr: trimmedAttr }]);
      setSelector('');
      setAttr('');
      selectorRef.current.focus(); // کرسر دوباره روی فیلد اولی
    }
  };

  // const removeAttr = (index) => {
  //   const updated = [...value];
  //   updated.splice(index, 1);
  //   onChange(updated);
  // };
  const removeAttr = (selector, attr) => {
    onChange(value.filter(item => !(item.selector === selector && item.attr === attr)));
  };
  

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addAttr();
    }
  };

  return (
    <div>
      <Space wrap style={{ marginBottom: 8 }}>
        {value.map((item) => (
          <Tag
            key={`${item.selector}-${item.attr}`} // به جای index
            closable
            onClose={() => removeAttr(item.selector, item.attr)}
            color="green"
          >
            {item.selector} → {item.attr}
          </Tag>
        ))}
      </Space>


      <Space
        direction={screens.xs ? "vertical" : "horizontal"} // موبایل: عمودی، دسکتاپ: افقی
        style={{ width: "100%" }}
      >
        <Input
          ref={selectorRef}
          placeholder="مثلاً img"
          value={selector}
          onChange={(e) => setSelector(e.target.value)}
          style={{ width: 120 }}
          onKeyDown={handleKeyDown}
        />
        <Input
          placeholder="مثلاً align"
          value={attr}
          onChange={(e) => setAttr(e.target.value)}
          style={{ width: 120 }}
          onKeyDown={handleKeyDown}
        />
        <Button type="primary" onClick={addAttr}>
          +
        </Button>
      </Space>
    </div>
  );
}

export default RemoveAttrsInput;
